export const SET_CONN_STATE = "SET_CONN_STATE"

export function setConnectionState(conn, reconn) {
    console.log("Connection state " + conn)
    return {
        type: SET_CONN_STATE,
        payload: {conn: conn, reconn: reconn}
    }
}